import { html as r, attr as d } from "@microsoft/fast-element";
import { FASTCheckbox as m, checkboxTemplate as h } from "@matrix42/fast-foundation";
import { checkboxStyles as l } from "./checkbox.styles.js";
var f = Object.defineProperty, p = (c, i, e, v) => {
  for (var t = void 0, n = c.length - 1, o; n >= 0; n--)
    (o = c[n]) && (t = o(i, e, t) || t);
  return t && f(i, e, t), t;
};
const s = class s extends m {
  constructor() {
    super(...arguments), this.indeterminate = !1;
  }
  checkedChanged(i, e) {
    super.checkedChanged(i, e), e ? this.classList.add("checked") : this.classList.remove("checked");
  }
  indeterminateChanged(i, e) {
    e ? this.classList.add("indeterminate") : this.classList.remove("indeterminate");
  }
};
s.definition = {
  name: "checkbox",
  template: () => h({
    checkedIndicator: r` <nova-icon name="check"></nova-icon>`,
    indeterminateIndicator: r` <nova-icon name="minus"></nova-icon>`
  }),
  styles: l
};
let a = s;
p([
  d({ mode: "boolean" })
], a.prototype, "indeterminate");
export {
  a as Checkbox
};
